import {
  toUpdatedOnString,
} from '../../apis/reconAuditApi';
import {
  API_FIELDS,
  formatUpdatedOn,
  formatDateMMDDYYYY,
} from './issueTypes';

export const BASE_COLUMNS = [
  { field: API_FIELDS.COMPANY, headerName: 'Company', width: 90, flex: 0 },
  {
    field: API_FIELDS.RECON_ID,
    headerName: 'Recon ID',
    width: 100,
    flex: 0,
  },
  {
    field: API_FIELDS.ORDER_NUM,
    headerName: 'Order #',
    width: 110,
    flex: 0,
  },
  {
    field: API_FIELDS.SUB_ORDER_NUM,
    headerName: 'Sub Order',
    width: 100,
    flex: 0,
  },
  {
    field: API_FIELDS.ITEM_NUMBER,
    headerName: 'Item #',
    width: 110,
    flex: 0,
  },
  {
    field: API_FIELDS.TRACKING_NUM,
    headerName: 'Tracking #',
    width: 140,
    flex: 0,
  },
  {
    field: API_FIELDS.HIBBERT_DELIVERY_DATE,
    headerName: 'Hibbert Delivery Date',
    width: 150,
    flex: 0,
    renderCell: (params) =>
      formatDateMMDDYYYY(params.row[API_FIELDS.HIBBERT_DELIVERY_DATE]),
  },
  {
    field: API_FIELDS.VEEVA_DELIVERY_DATE,
    headerName: 'Veeva Delivery Date',
    width: 150,
    flex: 0,
    renderCell: (params) =>
      formatDateMMDDYYYY(params.row[API_FIELDS.VEEVA_DELIVERY_DATE]),
  },
  {
    field: API_FIELDS.HIB_AOC_STATUS,
    headerName: 'HIB AOC Status',
    width: 130,
    flex: 0,
  },
  {
    field: API_FIELDS.VEEVA_AOC_STATUS,
    headerName: 'Veeva AOC Status',
    width: 140,
    flex: 0,
  },
  {
    field: API_FIELDS.RECON_STATUS,
    headerName: 'Recon Status',
    width: 160,
    flex: 0,
  },
  {
    field: API_FIELDS.VEEVA_ORD_IDENTIFIER,
    headerName: 'Veeva Ord ID',
    width: 140,
    flex: 0,
  },
  {
    field: API_FIELDS.VEEVA_AOC_IDENTIFER,
    headerName: 'Veeva AOC ID',
    width: 140,
    flex: 0,
  },
  {
    field: API_FIELDS.COMMENTS,
    headerName: 'Comments',
    flex: 1,
    minWidth: 200,
  },
  {
    field: API_FIELDS.PCR_NUM,
    headerName: 'PCR #',
    width: 110,
    flex: 0,
  },
  {
    field: API_FIELDS.UPDATED_BY,
    headerName: 'Updated By',
    width: 120,
    flex: 0,
  },
  {
    field: API_FIELDS.UPDATED_ON,
    headerName: 'Updated On',
    width: 150,
    flex: 0,
    renderCell: (params) => {
      const row = params.row;
      const raw = row[API_FIELDS.UPDATED_ON] ?? row.updated_on;
      const value = toUpdatedOnString(raw) ?? null;
      return formatUpdatedOn(value);
    },
  },
  {
    field: API_FIELDS.ACTIVE_FLAG,
    headerName: 'Active',
    width: 80,
    flex: 0,
    renderCell: (params) => {
      const v = params.row[API_FIELDS.ACTIVE_FLAG];
      return Number(v) === 1 ? 'Yes' : 'No';
    },
  },
];
